// Legal tab: card listing account policies; opens markdown modal per document

import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { legalDocuments } from '../legalDocuments';
import { LegalDocumentListItem } from './LegalDocumentListItem';
import { LegalDocumentModal } from './LegalDocumentModal';
import './LegalSection.css';

export function LegalSection() {
  const { legalAcceptance, legalAcceptanceComplete } = useAuth();
  const [openDocument, setOpenDocument] = useState(null);

  return (
    <div className="legal-section">
      <div className="account-card">
        <div className="card-header">
          <h2 className="card-title">
            <i className="fa-solid fa-scale-balanced" aria-hidden />
            Legal
          </h2>
        </div>
        <div className="card-body">
          <p className="legal-section-intro">
            Review Revolt policies that apply to your account, subscriptions, and use of the
            service.
            {!legalAcceptanceComplete && (
              <>
                {' '}
                One or more policies need your acceptance before you can use the site.
              </>
            )}
          </p>
          <div className="legal-document-list">
            {legalDocuments.map((doc) => (
              <LegalDocumentListItem
                key={doc.slug}
                document={doc}
                onSelect={setOpenDocument}
                statusMeta={legalAcceptance?.documents?.[doc.slug]}
              />
            ))}
          </div>
        </div>
      </div>

      <LegalDocumentModal
        document={openDocument}
        onClose={() => setOpenDocument(null)}
      />
    </div>
  );
}
